/**
 * Created by liwenqiang on 2018/3/21.
 */

const $ = require('jquery');
const HEAD_STRING = '/s/baike';

$._ajax = $.ajax;

$.ajax = function (url, options) {
    let headSrting = HEAD_STRING;

    if (typeof url === 'object') {
        if (url.realUrl) {
            headSrting = '';
        }
        url.url = headSrting + url.url;
    } else if (url) {
        if (options.realUrl) {
            headSrting = '';
        }
        url = headSrting + url;
    }

    return $._ajax(url, options);
};

module.exports = $;


//////////////////
// WEBPACK FOOTER
// ./src/jquery.js
// module id = 5
// module chunks = 0 1 2 3